import React, { useState } from 'react';
import { Box } from '@mui/material';
import { ICompany, IMembership } from '../../../../generated/graphql';
import PaperCard from '../../../Common/Layout/PaperCard';
import CustomAppBar from '../../../Common/Layout/CustomAppBar';
import TabPanel from '../../../Common/Layout/TabPanel';
import CompanyGeneralTab from './CompanyGeneralTab';
import CompanyContactsTab from './CompanyContactsTab';
import CompanyMembershipTab from './CompanyMembershipTab';

interface IProps {
  company: ICompany;
  updateMembershipProperty: (mem: IMembership) => void;
}

const CompanyDetailsTabs: React.FunctionComponent<IProps> = ({
  company,
  updateMembershipProperty
}: IProps) => {
  const [value, setValue] = useState(0);
  const handleChange = (_: unknown, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box className="centralize" sx={{ width: '100%', paddingTop: '80px' }}>
      <PaperCard width="82%" additionalStyle={{ height: '680px' }}>
        <CustomAppBar
          type="third"
          value={value}
          handleChange={handleChange}
          tabProps={[
            {
              id: 'General-Tab',
              title: 'General'
            },
            {
              id: 'Contacts-Tab',
              title: 'Contacts'
            },
            {
              id: 'Membership-Tab',
              title: 'Membership'
            }
          ]}
        />
        <TabPanel value={value} index={0}>
          <CompanyGeneralTab company={company} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <CompanyContactsTab companyId={parseInt(company.id)} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <CompanyMembershipTab
            membership={company.membership}
            companyName={company.name}
            companyId={company.id}
            updateMembershipProperty={updateMembershipProperty}
          />
        </TabPanel>
      </PaperCard>
    </Box>
  );
};

export default CompanyDetailsTabs;
